<template>
  <div>
    <highcharts
      :options="chartOptions"
      ref="lineCharts"
    ></highcharts>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";
import exportDataInit from "highcharts/modules/export-data";
import seriesLabelInit from "highcharts/modules/series-label";
import stockInit from "highcharts/modules/stock";
import accessibilityInit from "highcharts/modules/accessibility";
import formatPrice from '../../helpers/formatter';

stockInit(Highcharts);
exportingInit(Highcharts);
exportDataInit(Highcharts);
seriesLabelInit(Highcharts);
accessibilityInit(Highcharts);

export default {
  props: {
    xAxisCategories: {
      type: Array
    },
    yAxisTitle: {
      type: String
    },
    series: {
      type: Array
    },
    chartTitle:{
      type: String
    }
  },

  components: {
    highcharts: Chart
  },

  created() {
      this.chartOptions.xAxis.categories = this.xAxisCategories;
      this.chartOptions.series = this.series;
      this.chartOptions.title.text = this.chartTitle;
      this.chartOptions.yAxis.title.text = this.yAxisTitle;
  },

  data() {
    return {
      chartOptions: {
        title: {
          text: ''
        },
        chart: {
          type: "spline"
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        xAxis: {
          categories: [           
          ]
        },
        tooltip: {
          crosshairs: true,
          shared: true,
          pointFormatter: function() {
            return '<span style="color:' + this.series.color + '">' + this.series.name + '</span>: <b>' + formatPrice(this.y) + '</b><br />'
          },
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 6,
              lineColor: "#666666",
              lineWidth: 2
            }
          }
        },
        series: [          
        ]
      }
    };
  }
};
</script>
